import { Command, HttpVerbType, API_PREFIX, API_VERSION } from "../Command";
import { GetUsersBalanceReportReqData } from "./GetUsersBalanceReportReqData";
import { GetUsersBalanceReportResData } from "./GetUsersBalanceReportResData";

const ENDPOINT = "/cash_flow/users_balance";

export class GetUsersBalanceReportCommand extends Command {
    endPoint: string = API_PREFIX + API_VERSION + ENDPOINT;
    httpVerb: HttpVerbType = "post";

    params: GetUsersBalanceReportReqData = null;

    constructor(reqData: GetUsersBalanceReportReqData) {
        super();
        this.params = reqData;
    }

    public async execute(): Promise<GetUsersBalanceReportResData> {
        var res = await this.executeCommand(this.params);
        return new GetUsersBalanceReportResData(res);
    }
}
